import Image from "next/image";
import type { z } from "zod/v4";
import type { GameSchema } from "@/lib/schema";
import { getGameIconType } from "@/lib/utils";
import { pktenDragonTiger } from "@/utils/result";

export function Pk10Draw({
  gameData,
}: {
  gameData: z.infer<typeof GameSchema>;
}) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-1">
        {gameData.result.map((item, index) => (
          <Image
            key={`${index}-${item}`}
            src={`/ball/${getGameIconType("1062", gameData.roomId)}/${item}.png`}
            alt={item.toString()}
            width={32}
            height={32}
          />
        ))}
      </div>
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-1">
          {Array.from({ length: 5 }, (_, i) => (
            <span key={i.toString()} className="rounded-sm border px-2 py-1">
              {pktenDragonTiger(gameData.result, i + 1)}
            </span>
          ))}
        </div>
        <div className="flex items-center gap-1">
          <span>冠亚和</span>
          <span className="rounded-sm border px-2 py-1">
            {gameData.result[0] + gameData.result[1]}
          </span>
          <span className="rounded-sm border px-2 py-1">
            {gameData.result[0] + gameData.result[1] > 11 ? "大" : "小"}
          </span>
          <span className="rounded-sm border px-2 py-1">
            {(gameData.result[0] + gameData.result[1]) % 2 === 0 ? "双" : "单"}
          </span>
        </div>
      </div>
    </div>
  );
}
